/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import {
  CommandListLinkRel,
  CommandListResourceService,
  CommandListResourceServiceConfig,
  CommandService,
} from '@alfa-client/command-shared';
import { StateService } from '@common/tech-shared';
import { VorgangResource, VorgangService, VorgangWithEingangLinkRel } from '@alfa-client/vorgang-shared';
import { HistorieListResource, HistorieResource } from './+state/historie.model';
import { HISTORIE_FEATURE_KEY, HISTORIE_LIST_PATH } from './historie.state';

export class HistorieListResourceService extends CommandListResourceService<
  VorgangResource,
  HistorieListResource,
  HistorieResource
> {}

export function createHistorieListResourceService(
  vorgangService: VorgangService,
  commandService: CommandService,
  stateService: StateService,
) {
  return new HistorieListResourceService(buildConfig(vorgangService), commandService, stateService);
}

function buildConfig(vorgangService: VorgangService): CommandListResourceServiceConfig<VorgangResource> {
  return {
    stateInfo: { name: HISTORIE_FEATURE_KEY, path: HISTORIE_LIST_PATH },
    baseResource: vorgangService.selectVorgangWithEingang(),
    getLinkRel: VorgangWithEingangLinkRel.HISTORIE,
    listResourceListLinkRel: CommandListLinkRel.COMMAND_LIST,
  };
}
